import {
  HttpRequestEntity,
  HttpRequestModelType,
} from 'shared/domain/httpRequest/httpRequestModel';
import { debugLog } from 'shared/logger/debugLog';
import { neverReached } from 'shared/utils/neverReached';
import { broadcastCompanyResponse } from './company';
import { broadcastContractResponse } from './contract';
import { broadcastLevelResponse } from './level';
import { broadcastProjectResponse } from './project';
import { broadcastSiteResponse } from './site';
import { broadcastUserResponse } from './user';
import { broadcastIssueResponse } from './issue';
import { broadcastReportResponse } from './report';
import { broadcastVisibleFieldResponse } from './visibleField';
import {
  broadcastDocumentationMoveResponse,
  broadcastDocumentationResponse,
} from './documentation';
import { broadcastOrganizationResponse } from './organization';
import { broadcastDocumentationVersionResponse } from './documentationVersion';
import { broadcastInspectionResponse } from './inspection';
import { broadcastProtocolItemResponse } from './protocolItem';
import { broadcastProtocolAnswerResponse } from './protocolAnswer';
import { broadcastInspectionTemplateResponse } from './inspectionTemplate';
import { broadcastChecklistSectionResponse } from './checklistSection';
import { broadcastChecklistAnswerResponse } from './checklistAnswer';
import { broadcastProtocolSectionResponse } from './protocolSection';
import { broadcastProtocolSectionAnswersBatchResponse } from './protocolSectionAnswersBatch';
import { broadcastWorkflowResponse } from './workflow';
import { broadcastStageResponse } from './stage';
import { broadcastDecisionResponse } from './decision';
import { broadcastProcessResponse } from './process';

export function emitResponseOnProperChannel(
  request: HttpRequestEntity,
  response: any,
  uniqueId?: string
): void {
  debugLog('emitResponseOnProperChannel', request.entityType);
  switch (request.entityType) {
    case HttpRequestModelType.issue:
      return broadcastIssueResponse(request, response);
    case HttpRequestModelType.report:
      return broadcastReportResponse(request, response, uniqueId);
    case HttpRequestModelType.documentation:
      return broadcastDocumentationResponse(request, response);
    case HttpRequestModelType.documentationVersion:
      return broadcastDocumentationVersionResponse(request, response);
    case HttpRequestModelType.documentationMove:
      return broadcastDocumentationMoveResponse(request, response);
    case HttpRequestModelType.level:
      return broadcastLevelResponse(request, response);
    case HttpRequestModelType.site:
      return broadcastSiteResponse(request, response);
    case HttpRequestModelType.directory:
    case HttpRequestModelType.document:
    case HttpRequestModelType.documentationDelete:
    case HttpRequestModelType.documentationRestore:
    case HttpRequestModelType.drawing:
      return;
    case HttpRequestModelType.visibleField:
      return broadcastVisibleFieldResponse(request, response);
    case HttpRequestModelType.project:
      return broadcastProjectResponse(request, response);
    case HttpRequestModelType.organization:
      return broadcastOrganizationResponse(request, response);
    case HttpRequestModelType.company:
      return broadcastCompanyResponse(request, response);
    case HttpRequestModelType.contract:
      return broadcastContractResponse(request, response);
    case HttpRequestModelType.user:
      return broadcastUserResponse(request, response);
    case HttpRequestModelType.inspection:
      return broadcastInspectionResponse(request, response);
    case HttpRequestModelType.protocolItem:
      void broadcastProtocolItemResponse(request, response);
      return;
    case HttpRequestModelType.protocolAnswer:
      void broadcastProtocolAnswerResponse(request, response);
      return;
    case HttpRequestModelType.inspectionTemplate:
      return broadcastInspectionTemplateResponse(request, response);
    case HttpRequestModelType.checklistSection:
    case HttpRequestModelType.checklistSectionDocument:
      return broadcastChecklistSectionResponse(request, response);
    case HttpRequestModelType.checklistAnswer:
      return broadcastChecklistAnswerResponse(request, response);
    case HttpRequestModelType.protocolSection:
      broadcastProtocolSectionResponse(request, response);
      return;
    case HttpRequestModelType.protocolSectionAnswersBatch:
      void broadcastProtocolSectionAnswersBatchResponse(request, response);
      return;
    case HttpRequestModelType.workflow:
      return broadcastWorkflowResponse(request, response);
    case HttpRequestModelType.workflowStage:
      return broadcastStageResponse(request, response);
    case HttpRequestModelType.workflowStageReorder:
      return broadcastStageResponse(request, response);
    case HttpRequestModelType.workflowDecision:
      return broadcastDecisionResponse(request, response);
    case HttpRequestModelType.process:
      return broadcastProcessResponse(request, response);
    default:
      // ensure every case is handled when we add new type.
      neverReached(request.entityType);
  }
}